import styled from 'styled-components';

const Container = styled.div`
	padding: 20px;
	max-height: 360px;
	width: 45vw;

	@media (max-width: 1200px) {
		width: 70vw;
		max-height: 200px;
	}
`;

const FilterButton = styled.button`
	margin: 1rem 0 0;
	background-color: rgb(235,235,240);
	border: 0;
	color: rgb(80,80,80);
	padding: 0.3rem 0.6rem;
	border-radius: 0.25rem;
	cursor: pointer;
	opacity: 0.7;
	transition: all 0.2s ease-out;

	&:hover {
		opacity: 1;
	}
`;

const BuildingSpaceLink = styled.button`
	background: transparent;
	border: none;
	box-shadow: none;
	color: #4A90E2;
	cursor: pointer;
	padding: 0;
	margin: 0;
	font-size: 1rem;
	transition: color 0.2s ease;

	&:hover {
		text-decoration: underline;
	}
`;

export {
	Container,
	FilterButton,
	BuildingSpaceLink
}
